import {Route, Routes} from "react-router-dom";
import OrganizationList from "./OrganizationList";
import OrganizationDetails from "./Detail/OrganizationDetails";
import EetsDeviceDetails from "./Detail/EetsDeviceDetail";
import {PermissionLevel} from "../../app/api/model/user";
import RequireAuth from "../../components/RequireAuth";

export default function Organizations() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<OrganizationList />} />
                <Route path=":organizationId" element={<OrganizationDetails />} />
                <Route path=":organizationId/eetsDevices/:eetsDeviceId" element={<EetsDeviceDetails />} />
            </Routes>
        </RequireAuth>
    );
}
